/** Locale resolution for the localized public routes (`/en`, `/id`). */

import {
  DEFAULT_LOCALE,
  FALLBACK_LOCALE,
  LOCALES,
  SUPPORTED_LOCALES,
  type Locale,
} from "../constants/config";
import { en } from "./en";
import { id } from "./id";
import type { PublicDictionary } from "./types";

export const DICTIONARIES: Record<Locale, PublicDictionary> = { en, id };

export const getDictionary = (locale: Locale): PublicDictionary =>
  DICTIONARIES[locale] ?? DICTIONARIES[DEFAULT_LOCALE];

const isSupportedLocale = (value: string): value is Locale =>
  SUPPORTED_LOCALES.includes(value as Locale);

/** `["id-ID", "en-US"]` → `id`; unknown languages fall back to English. */
export const matchBrowserLocale = (languages: readonly string[]): Locale => {
  for (const language of languages) {
    const base = language.toLowerCase().split("-")[0] ?? "";
    if (isSupportedLocale(base)) return base;
  }
  return FALLBACK_LOCALE;
};

export const resolveLocale = (
  candidate?: string | null,
  languages: readonly string[] = [],
): Locale => {
  if (candidate && isSupportedLocale(candidate)) return candidate;
  if (languages.length > 0) return matchBrowserLocale(languages);
  return DEFAULT_LOCALE;
};

export const otherLocale = (locale: Locale): Locale =>
  locale === LOCALES.en ? LOCALES.id : LOCALES.en;
